var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Composant_38_2",
    "data-name": "Composant 38 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5569",
    "data-name": "Rectangle 5569",
    width: 56,
    height: 56,
    rx: 20,
    fill: "#ec6321"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-question",
    "data-name": "Icon awesome-question",
    d: "M10.759,0a9.839,9.839,0,0,0-8.74,4.622,1.22,1.22,0,0,0,.263,1.669L4.473,7.953a1.219,1.219,0,0,0,1.689-.211c1.272-1.594,2.216-2.511,4.2-2.511,1.562,0,3.495,1.005,3.495,2.52,0,1.145-.945,1.733-2.488,2.6-1.8,1.009-4.179,2.264-4.179,5.4v.5A1.219,1.219,0,0,0,8.41,17.469h3.68a1.219,1.219,0,0,0,1.219-1.219v-.293c0-2.176,6.361-2.267,6.361-8.157C19.67,3.365,15.069,0,10.759,0ZM10.25,18.965a3.518,3.518,0,1,0,3.518,3.518A3.522,3.522,0,0,0,10.25,18.965Z",
    transform: "translate(17.2 15)",
    fill: "#fff",
    opacity: 0.999
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionFaq);
export default __webpack_public_path__ + "static/media/QuestionFaq.328617f909cc8668756aa3d12c8a16ac.svg";
export { ForwardRef as ReactComponent };